import { render } from "./ScienceItem.vue?vue&type=template&id=40afc46e&scoped=true"
import script from "./ScienceItem.vue?vue&type=script&lang=js"
export * from "./ScienceItem.vue?vue&type=script&lang=js"

import "./ScienceItem.vue?vue&type=style&index=0&id=40afc46e&lang=scss&scoped=true"

import exportComponent from "E:\\uni-app项目\\kxsns-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40afc46e"]])

export default __exports__